import { ExposureTwoTone } from "@material-ui/icons"
import { getEnvVariable } from "../../modules/environmentalList"

export const NotAdminRegList = {
    'MPS': {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#00bfa5'
                    }
                },
                {
                    "type": "menu",
                    "title": "My Dashboards",
                    "icon": "fa fa-cogs",
                    "materialicon": "dashboard",
                    "link": "/userdashboardflows",
                    "key": "userdashboardflows",
                    "style": {
                        'color': '#00a152'
                    }
                }, 
                // {
                //     "type": "menu",
                //     "title": "Statistics",
                //     "icon": "poll",
                //     "materialicon": "poll",
                //     "link": "/systemstatistics",
                //     "key": "Statistics",
                //     "style": {
                //         'color': '#A020F0'
                //     }
                // },
            ],
        "myportallist":
            [
                // {
                //     "type": "menu",
                //     "title": "Classic Search",
                //     "icon": "search",
                //     "materialicon": "search",
                //     "link": "/search",
                //     "key": "Search",
                //     "style": {
                //         'color': '#61A5DC'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "find_in_page",
                    "materialicon": "find_in_page",
                    "link": "/advsearch",
                    "key": "Search",
                    "style": {
                        'color': '#e65100'
                    }
                },
                {
                    "type": "menu",
                    "title": "Process Flows",
                    "icon": "fa fa-cogs",
                    "materialicon": "schema",
                    "link": "/userprocessflows",
                    "key": "userprocessflows",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Administration/applications",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },

                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Companies",
                //     "icon": "fa fa-building",
                //     "link": "#/Administration/companies",
                //     "key": "companies",
                //     "materialicon": "apartment",
                //     "style": {
                //         'color': '#ea156d'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "Companies Approval",
                //     "key": "registrationrequest",
                //     "link": "/Administration/registrationrequest",
                //     "icon": "fa fa-caret-square-o-right",
                //     "materialicon": "how_to_vote",
                //     "style": {
                //         'color': '#9fa8da'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "Contacts Directory",
                //     "key": "contacts",
                //     "link": "/Administration/globalexternalcontacts",
                //     "icon": "fa fa-user-circle-o",
                //     "materialicon": "contacts",
                //     "style": {
                //         'color': '#006064'
                //     }
                // }
            ],
        "publichublist":
            [

                {
                    "type": "menu",
                    "title": "Companies",
                    "icon": "fa fa-building",
                    "link": "/Administration/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Consultants",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/consultants",
                //     "key": "consultants",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "External Users",
                    "icon": "fa fa-users",
                    "link": "/Administration/externalusers",
                    "key": "ExternalUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Individuals",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/companies",
                //     "key": "companies",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Companies Approval",
                    "key": "registrationrequest",
                    "link": "/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
                {
                    "type": "menu",
                    "title": "Company Approval Users",
                    "icon": "assignment_turned_in",
                    "materialicon": "assignment_turned_in",
                    "link": "/Portal/Approvals",
                    "key": "Search",
                    "style": {
                        'color': '#1b5e20'
                    }
                },
                {
                    "type": "menu",
                    "title": "Contacts Directory",
                    "key": "contacts",
                    "link": "/Administration/globalexternalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                }
            ],
        // "Adminlist":
        //     [

        //         {
        //             "type": "menu",
        //             "title": "Registrations",
        //             "key": "registrationrequest",
        //             "link": "#/Administration/registrationrequest",
        //             "icon": "fa fa-caret-square-o-right",
        //             "materialicon": "how_to_vote",
        //             "style": {
        //                 'color': '#9fa8da'
        //             }
        //         },
        //     ],
    },

}
